<h1 mat-dialog-title>{{ model.header }}</h1>
<mat-dialog-content class="mat-typography">
    <ul>
        <li>
            {{ model.message }}
        </li>
    </ul> 
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="default-button-color" (click)="close()">
        {{ model.closeLabel }}
    </button>
</mat-dialog-actions>
